import { Component, OnInit, ViewChild } from '@angular/core';
import { FirelightApiService } from 'src/app/core/services/http/firelight-api.service';
import { ActivityResponse } from 'src/app/shared/models/firelightApi.models';
import { Router } from '@angular/router';
import { SsoService } from 'src/app/core/services/sso.service';
import { MatDialog } from '@angular/material/dialog';
import { CopyApplicationModalComponent } from 'src/app/portal/modals/copy-application-modal/copy-application-modal.component';
import { orderBy } from 'lodash';
import { fadeIn } from 'src/app/animations';
import { SubmitApplicationModalComponent } from 'src/app/portal/modals/submit-application-modal/submit-application-modal.component';
import { sidenavConfig } from 'src/app/shared/models/sidenav-config.model';
import { BreakpointObserver } from '@angular/cdk/layout';
import { environment } from 'src/environments/environment';
import { searchFilter } from 'src/app/shared/helpers/search.helper';
import { EApplicationDownloadsComponent } from 'src/app/portal/modals/e-application-downloads/e-application-downloads.component';
import { EAppService } from 'src/app/core/services/e-app.service';

@Component({
  animations: [fadeIn],
  selector: 'app-application-history',
  templateUrl: './application-history.component.html',
})
export class ApplicationHistoryComponent implements OnInit {
  @ViewChild('sidenav') sidenav: any;
  columnName: string = 'Date';
  loadingList: boolean = false;
  pastApplications!: ActivityResponse[];
  reverseOrder: boolean = false;
  environment = environment;
  sidenavConfig: sidenavConfig = {
    IsOpened: true,
    Mode: 'side',
  };
  searchText: string = '';

  constructor(
    private dialog: MatDialog,
    private firelightApiService: FirelightApiService,
    private router: Router,
    private ssoService: SsoService,
    private breakpointObserver: BreakpointObserver,
    private eAppService:EAppService
  ) {
    this.sidenavConfig = {
      IsOpened: true,
      Mode: 'side',
    };
  }

  ngOnInit(): void {
    this.breakpointObserver.observe([
      '(min-width: 1440px)'
    ]).subscribe(state => {
      if (state.matches) {
        this.sidenavConfig = {
          IsOpened: true,
          Mode: 'side',
        };
      } else {
        this.sidenavConfig = {
          IsOpened: false,
          Mode: 'over',
        };
      }
    });
    this.loadingList = true;
    this.firelightApiService.getFirelightApplicationHistory()
      .subscribe(
        {
          next: (activities:ActivityResponse[]) => {
            this.pastApplications = activities;
          },
          error: () => {
            if (environment.local) {
              alert('this.firelightApiService.getFirelightApplicationHistory() failed. This is only mock data for local');
              this.pastApplications = mockApplications;
            }
          }})
      .add(() => {
        this.loadingList = false;
      });
  }


  activateFirelightSso(): void {
    this.ssoService.firelightSso();
  }

  activateIpipelineSso(): void {
    this.ssoService.iPipelineEAppsSso();
  }

  addSpaceBetweenCapitals(word: string):string {
    return word.replace(/([A-Z])/g, ' $1').trim();
  }

  filterBySearchText(resources: ActivityResponse[], searchText: string): ActivityResponse[] {
    if (searchText.length > 0) return resources.filter(item => searchFilter(item, searchText));
    else return resources;
  }

  goToActivity(activityId: string): void {
    this.eAppService.goToFirelight(activityId, {isNew: false});
  }

  // This is a direct sso into a firelight app as a backup for the embedded experience
  goToActivityInFirelight(activityId: string): void {
    this.ssoService.firelightSso(activityId);
  }

  goToMyBusiness(): void {
    this.router.navigate(['/Portal/MyBusiness']);
  }

  openCopyFireLightModal(activityResponse: ActivityResponse): void {
    this.dialog.open(CopyApplicationModalComponent, {
      data: {
        activityId: activityResponse.ActivityId,
      },
      height: '60rem',
      width: '54rem',
    });
  }

  openEApplicationDownloadsModal(activityResponse: ActivityResponse): void {
    this.dialog.open(EApplicationDownloadsComponent, {
      data: activityResponse,
      width: '42rem',
    });
  }

  openEAppGuide(): void {
    window.open('https://www.figmarketing.com/files/resources/EApp_Quick_Start_Guide.pdf');
  }

  openSubmitApplicationModal(): void {
    this.dialog.open(SubmitApplicationModalComponent);
  }

  orderRows(columnName: string): void {
    if (columnName.toString() === this.columnName.toString()) {
      this.reverseOrder = !this.reverseOrder;
    } else {
      this.columnName = columnName;
    }
    const order = this.reverseOrder ? 'asc' : 'desc';

    switch (columnName) {
      case 'CaseName':
        this.pastApplications = orderBy(this.pastApplications, ['ActivityName'], order as ('asc' | 'desc'));
        break;
      case 'CarrierProduct':
        this.pastApplications = orderBy(this.pastApplications, ['ProductName'], order as ('asc' | 'desc'));
        break;
      case 'Lob':
        this.pastApplications = orderBy(this.pastApplications, ['ProductCategory'], order as ('asc' | 'desc'));
        break;
      case 'Date':
        this.pastApplications = orderBy(this.pastApplications, ['AuditDate'], order as ('asc' | 'desc'));
        break;
      case 'Status':
        this.pastApplications = orderBy(this.pastApplications, ['DisplayStatus'], order as ('asc' | 'desc'));
    }
  }

  toggleSidenav(): void {
    this.sidenav.toggle();
  }
}


export const mockApplications: any = [
  { 'ActivityId': '8767ba14-ca38-4df6-b611-f411288ad775', 'PolicyGuid': null, 'ActivityName': 'AP Index Advantage Test 5-7', 'AuditDate': '2021-05-13T19:40:45.5', 'Status': 'ActiveApplication', 'DataItemsMap': { 'FLI_ISSUED_STATE_ABBREV': 'NC', 'FLI_PRODUCT_CARRIER_NAME': 'Allianz', 'FLI_PRODUCT_CATEGORY': 'Annuity', 'FLI_PRODUCT_NAME': 'Allianz Index Advantage ADV' } }, { 'ActivityId': 'b9c61fe0-ac4d-4b23-bf58-d36e82657803', 'PolicyGuid': null, 'ActivityName': 'AP Index Advantage Test 5-7', 'AuditDate': '2021-05-13T19:09:20.143', 'Status': 'ActiveApplication', 'DataItemsMap': { 'FLI_ISSUED_STATE_ABBREV': 'NC', 'FLI_PRODUCT_CARRIER_NAME': 'Allianz', 'FLI_PRODUCT_CATEGORY': 'Annuity', 'FLI_PRODUCT_NAME': 'Allianz Index Advantage ADV' } }, { 'ActivityId': 'e0e830bd-01e4-4a97-a4a9-ad443b0fcee0', 'PolicyGuid': null, 'ActivityName': 'AP Index Advantage Test 5-7', 'AuditDate': '2021-05-13T19:06:58.387', 'Status': 'ActiveApplication', 'DataItemsMap': { 'FLI_ISSUED_STATE_ABBREV': 'NC', 'FLI_PRODUCT_CARRIER_NAME': 'Allianz', 'FLI_PRODUCT_CATEGORY': 'Annuity', 'FLI_PRODUCT_NAME': 'Allianz Index Advantage ADV' } }, { 'ActivityId': 'fa448e5e-b6b7-46e3-837d-c674bb92654c', 'PolicyGuid': null, 'ActivityName': 'AP 222 QA test 5-7', 'AuditDate': '2021-05-13T18:54:39.12', 'Status': 'ActiveApplication', 'DataItemsMap': { 'FLI_ISSUED_STATE_ABBREV': 'NC', 'FLI_PRODUCT_CARRIER_NAME': 'Allianz', 'FLI_PRODUCT_CATEGORY': 'Annuity', 'FLI_PRODUCT_NAME': 'Allianz 222 Annuity' } }, { 'ActivityId': 'fa833bd2-26f8-46c0-93d0-9b9c54e7cea7', 'PolicyGuid': null, 'ActivityName': 'New Application - Index Protector 7 (MVA)', 'AuditDate': '2021-05-12T14:07:01.62', 'Status': 'ActiveApplication', 'DataItemsMap': { 'FLI_ISSUED_STATE_ABBREV': 'NC', 'FLI_PRODUCT_CARRIER_NAME': 'Great American Insurance Group', 'FLI_PRODUCT_CATEGORY': 'Annuity', 'FLI_PRODUCT_NAME': 'Index Protector 7 (MVA)' } }, { 'ActivityId': 'da9080e1-b2d7-41c4-843d-c0eea8cc1ab3', 'PolicyGuid': null, 'ActivityName': '222 test ap 5-7', 'AuditDate': '2021-05-12T14:06:32.51', 'Status': 'ActiveApplication', 'DataItemsMap': { 'FLI_ISSUED_STATE_ABBREV': 'MN', 'FLI_PRODUCT_CARRIER_NAME': 'Allianz', 'FLI_PRODUCT_CATEGORY': 'Annuity', 'FLI_PRODUCT_NAME': 'Allianz 222 Annuity' } }, { 'ActivityId': 'd6c62364-576b-437c-84b7-65e4deeac2f9', 'PolicyGuid': null, 'ActivityName': 'AP 222 QA test 5-7', 'AuditDate': '2021-05-12T14:06:20.43', 'Status': 'ActiveApplication', 'DataItemsMap': { 'FLI_ISSUED_STATE_ABBREV': 'NC', 'FLI_PRODUCT_CARRIER_NAME': 'Allianz', 'FLI_PRODUCT_CATEGORY': 'Annuity', 'FLI_PRODUCT_NAME': 'Allianz 222 Annuity' } }, { 'ActivityId': 'ae6c7123-6cdf-4b12-8f87-45a8a339400f', 'PolicyGuid': null, 'ActivityName': 'test ind adv', 'AuditDate': '2021-05-11T18:36:44.773', 'Status': 'ActiveApplication', 'DataItemsMap': { 'FLI_ISSUED_STATE_ABBREV': 'NC', 'FLI_PRODUCT_CARRIER_NAME': 'Allianz', 'FLI_PRODUCT_CATEGORY': 'Annuity', 'FLI_PRODUCT_NAME': 'Allianz Index Advantage ADV' } }, { 'ActivityId': '3c71e6fb-9126-404e-95b2-7a0e9b3152ae', 'PolicyGuid': null, 'ActivityName': 'New Application - Guaranty Rate Lock', 'AuditDate': '2021-05-10T19:01:54.94', 'Status': 'Complete', 'DataItemsMap': { 'FLI_ISSUED_STATE_ABBREV': 'TN', 'FLI_PRODUCT_CARRIER_NAME': 'Guaranty Income Life Insurance company', 'FLI_PRODUCT_CATEGORY': 'Annuity', 'FLI_PRODUCT_NAME': 'Guaranty Rate Lock' } }, { 'ActivityId': '9ad88481-1801-4df7-933b-8c5457a6e68a', 'PolicyGuid': null, 'ActivityName': ' sd adssd', 'AuditDate': '2021-05-07T13:20:00.387', 'Status': 'ActiveApplication', 'DataItemsMap': { 'FLI_ISSUED_STATE_ABBREV': 'NC', 'FLI_PRODUCT_CARRIER_NAME': 'Allianz', 'FLI_PRODUCT_CATEGORY': 'Annuity', 'FLI_PRODUCT_NAME': 'Allianz 222 Annuity' } }, { 'ActivityId': '8767ba14-ca38-4df6-b611-f411288ad775', 'PolicyGuid': null, 'ActivityName': 'AP Index Advantage Test 5-7', 'AuditDate': '2021-05-13T19:40:45.5', 'Status': 'ActiveApplication', 'DataItemsMap': { 'FLI_ISSUED_STATE_ABBREV': 'NC', 'FLI_PRODUCT_CARRIER_NAME': 'Allianz', 'FLI_PRODUCT_CATEGORY': 'Annuity', 'FLI_PRODUCT_NAME': 'Allianz Index Advantage ADV' } }, { 'ActivityId': 'b9c61fe0-ac4d-4b23-bf58-d36e82657803', 'PolicyGuid': null, 'ActivityName': 'AP Index Advantage Test 5-7', 'AuditDate': '2021-05-13T19:09:20.143', 'Status': 'ActiveApplication', 'DataItemsMap': { 'FLI_ISSUED_STATE_ABBREV': 'NC', 'FLI_PRODUCT_CARRIER_NAME': 'Allianz', 'FLI_PRODUCT_CATEGORY': 'Annuity', 'FLI_PRODUCT_NAME': 'Allianz Index Advantage ADV' } }, { 'ActivityId': 'e0e830bd-01e4-4a97-a4a9-ad443b0fcee0', 'PolicyGuid': null, 'ActivityName': 'AP Index Advantage Test 5-7', 'AuditDate': '2021-05-13T19:06:58.387', 'Status': 'ActiveApplication', 'DataItemsMap': { 'FLI_ISSUED_STATE_ABBREV': 'NC', 'FLI_PRODUCT_CARRIER_NAME': 'Allianz', 'FLI_PRODUCT_CATEGORY': 'Annuity', 'FLI_PRODUCT_NAME': 'Allianz Index Advantage ADV' } }, { 'ActivityId': 'fa448e5e-b6b7-46e3-837d-c674bb92654c', 'PolicyGuid': null, 'ActivityName': 'AP 222 QA test 5-7', 'AuditDate': '2021-05-13T18:54:39.12', 'Status': 'ActiveApplication', 'DataItemsMap': { 'FLI_ISSUED_STATE_ABBREV': 'NC', 'FLI_PRODUCT_CARRIER_NAME': 'Allianz', 'FLI_PRODUCT_CATEGORY': 'Annuity', 'FLI_PRODUCT_NAME': 'Allianz 222 Annuity' } }, { 'ActivityId': 'fa833bd2-26f8-46c0-93d0-9b9c54e7cea7', 'PolicyGuid': null, 'ActivityName': 'New Application - Index Protector 7 (MVA)', 'AuditDate': '2021-05-12T14:07:01.62', 'Status': 'ActiveApplication', 'DataItemsMap': { 'FLI_ISSUED_STATE_ABBREV': 'NC', 'FLI_PRODUCT_CARRIER_NAME': 'Great American Insurance Group', 'FLI_PRODUCT_CATEGORY': 'Annuity', 'FLI_PRODUCT_NAME': 'Index Protector 7 (MVA)' } }, { 'ActivityId': 'da9080e1-b2d7-41c4-843d-c0eea8cc1ab3', 'PolicyGuid': null, 'ActivityName': '222 test ap 5-7', 'AuditDate': '2021-05-12T14:06:32.51', 'Status': 'ActiveApplication', 'DataItemsMap': { 'FLI_ISSUED_STATE_ABBREV': 'MN', 'FLI_PRODUCT_CARRIER_NAME': 'Allianz', 'FLI_PRODUCT_CATEGORY': 'Annuity', 'FLI_PRODUCT_NAME': 'Allianz 222 Annuity' } }, { 'ActivityId': 'd6c62364-576b-437c-84b7-65e4deeac2f9', 'PolicyGuid': null, 'ActivityName': 'AP 222 QA test 5-7', 'AuditDate': '2021-05-12T14:06:20.43', 'Status': 'ActiveApplication', 'DataItemsMap': { 'FLI_ISSUED_STATE_ABBREV': 'NC', 'FLI_PRODUCT_CARRIER_NAME': 'Allianz', 'FLI_PRODUCT_CATEGORY': 'Annuity', 'FLI_PRODUCT_NAME': 'Allianz 222 Annuity' } }, { 'ActivityId': 'ae6c7123-6cdf-4b12-8f87-45a8a339400f', 'PolicyGuid': null, 'ActivityName': 'test ind adv', 'AuditDate': '2021-05-11T18:36:44.773', 'Status': 'ActiveApplication', 'DataItemsMap': { 'FLI_ISSUED_STATE_ABBREV': 'NC', 'FLI_PRODUCT_CARRIER_NAME': 'Allianz', 'FLI_PRODUCT_CATEGORY': 'Annuity', 'FLI_PRODUCT_NAME': 'Allianz Index Advantage ADV' } }, { 'ActivityId': '3c71e6fb-9126-404e-95b2-7a0e9b3152ae', 'PolicyGuid': null, 'ActivityName': 'New Application - Guaranty Rate Lock', 'AuditDate': '2021-05-10T19:01:54.94', 'Status': 'Complete', 'DataItemsMap': { 'FLI_ISSUED_STATE_ABBREV': 'TN', 'FLI_PRODUCT_CARRIER_NAME': 'Guaranty Income Life Insurance company', 'FLI_PRODUCT_CATEGORY': 'Annuity', 'FLI_PRODUCT_NAME': 'Guaranty Rate Lock' } }, { 'ActivityId': '9ad88481-1801-4df7-933b-8c5457a6e68a', 'PolicyGuid': null, 'ActivityName': ' sd adssd', 'AuditDate': '2021-05-07T13:20:00.387', 'Status': 'ActiveApplication', 'DataItemsMap': { 'FLI_ISSUED_STATE_ABBREV': 'NC', 'FLI_PRODUCT_CARRIER_NAME': 'Allianz', 'FLI_PRODUCT_CATEGORY': 'Annuity', 'FLI_PRODUCT_NAME': 'Allianz 222 Annuity' } },
];